
import React, { useMemo, forwardRef, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Grid, Paper, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useTheme } from '@material-ui/core/styles';
import { ModulosGeneral } from './modulosGeneral';
import MigaPan from '../../../../app/orussystem/component/MigaPan';
import { getModulosGenerales, getlist } from '../../../domain/api/EvbiApi';

export const ModulosGenerales = ({ handledEditSettings, data, handleSupervisor }) => {
    const [id_list, setid_list] = useState("");
    const [list_modulos, setlist_modulos] = useState([]);
    const dispatch = useDispatch();
    const theme = useTheme();
    const [evbiOptions, setEvbiOptions] = useState([]);

    let to = `/basculas/mediciones/${id_list}`;
    const history = useHistory();
    

    const renderLink = useMemo(() => forwardRef((itemProps, ref) => <RouterLink to={to} ref={ref} {...itemProps} />),
        [to, id_list],
    );


    let toUser = `/mediciones/user/${id_list}`;
    const renderUserMachineLink = useMemo(() => forwardRef((itemProps, ref) => <RouterLink to={toUser} ref={ref} {...itemProps} />),
        [toUser],
    );
    let toAlcolimetria = `/basculas/alcoholimetria/${id_list}`;
    const alcolimetriaLink = useMemo(() => forwardRef((itemProps, ref) => <RouterLink to={toAlcolimetria} ref={ref} {...itemProps} />),
        [to, id_list],
    );



    const handledViewImc = (id) => {
        setid_list(id);
    };

    const handledViewUsers = (id, name) => {
        const params = {
            nameBascula: name
        };
        setTimeout(() => {
            history.push(`/mediciones/user/${id}`, params);
            setid_list(id);
        }, 500);
    };

    const handledViewAcolimetria = (id, name) => {
        const params = {
            nombre: name
        };
        setTimeout(() => {
            history.push(`/basculas/alcoholimetria/${id}`, params);
            setid_list(id);
        }, 2000);
    };


    const handledViewPolls = (id) => {
        history.push(`/poll/encuestas/${id}`);
        setid_list(id);
    };


    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(!open);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const primaryColor = theme.palette.primary.main;
    useEffect(async () => {

        const result = await getModulosGenerales()
        const evbiList = await getlist(dispatch, "", 0, 100);
        setEvbiOptions(evbiList.content);
        setlist_modulos(result.respuesta)


    }, [])
    const reload = async () => {
        const result = await getModulosGenerales()
        const evbiList = await getlist(dispatch, "", 0, 100);
        setEvbiOptions(evbiList.content);
        setlist_modulos(result.respuesta)
    };

    return (
        <>
            <Grid item xs={12} >
                <br></br>
                <br></br>
                <br></br>

                <MigaPan
                    namePage="Modulos"
                    to="/"
                    namePage2="Administracion"
                    to2="/Administracion"

                >
                    Home
                </MigaPan>
            </Grid>
            <Paper style={{ width: '100%' }}>
                <Grid container spacing={2} alignItems="center">

                    <Grid item xs={6}>

                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={3}>
                                <Typography variant="h6" style={{
                                    textAlign: 'left', fontSize: '25px',
                                    fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
                                    color: primaryColor, marginBottom: "3%", fontWeight: 'bold',
                                    marginLeft: '35%'
                                }}>Nombre</Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <Typography variant="h6" style={{
                                    textAlign: 'left', fontSize: '25px',
                                    fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
                                    color: primaryColor, marginBottom: "3%", fontWeight: 'bold',
                                    marginLeft: '16%'
                                }}>Estado</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="h6" style={{
                                    textAlign: 'left', fontSize: '25px',
                                    fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
                                    color: primaryColor, marginBottom: "3%", fontWeight: 'bold',
                                    marginLeft: '',
                                    marginLeft: '-6%'
                                }}>Última Conexión</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="h6" style={{
                                    textAlign: 'left', fontSize: '25px',
                                    fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
                                    color: primaryColor, marginBottom: "3%", fontWeight: 'bold',
                                    marginLeft: '-9%'
                                }}>EVBI</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {list_modulos === undefined || list_modulos.length === 0 ? (
                    <Typography variant="h4" style={{ textAlign: 'center', marginLeft: '2%', fontSize: '25px' }}>
                        No hay módulos disponibles.
                    </Typography>
                ) : (

                    <ModulosGeneral
                        rows={list_modulos}
                        renderLink={renderLink}
                        renderUserMachineLink={renderUserMachineLink}
                        alcolimetriaLink={alcolimetriaLink}
                        handleClick={handleClick}
                        handleClose={handleClose}
                        handledViewImc={handledViewImc}
                        handledViewUsers={handledViewUsers}
                        handledViewAcolimetria={handledViewAcolimetria}
                        handledViewPolls={handledViewPolls}
                        handledEditSettings={handledEditSettings}
                        handleSupervisor={handleSupervisor}
                        evbiOptions={evbiOptions}
                        reload={reload}
                    />


                )}
            </Paper>
        </>
    );
};
